import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const [toastMessage, setToastMessage] = useState('');

  const handleExternalLink = (linkName: string) => {
    setToastMessage(`${linkName} - Coming soon!`);
    setTimeout(() => setToastMessage(''), 3000);
  };

  return (
    <>
      {/* Toast Notification */}
      {toastMessage && (
        <div className="fixed top-4 right-4 bg-slate-800 border border-slate-700 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-slideIn">
          {toastMessage}
        </div>
      )}
      
      <footer className="bg-slate-900 border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-2xl">🏇</span>
              <span className="text-xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                SUI-ndicate
              </span>
            </div>
            <p className="text-slate-400">
              The future of thoroughbred racing on blockchain
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Platform</h3>
            <div className="space-y-2">
              <Link to="/dashboard" className="block text-slate-400 hover:text-cyan-400 transition-colors">
                Dashboard
              </Link>
              <Link to="/horses" className="block text-slate-400 hover:text-cyan-400 transition-colors">
                Our Horses
              </Link>
              <Link to="/governance" className="block text-slate-400 hover:text-cyan-400 transition-colors">
                Governance
              </Link>
            </div>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <div className="space-y-2">
              <button 
                onClick={() => handleExternalLink('Terms of Service')}
                className="block text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Terms of Service
              </button>
              <button 
                onClick={() => handleExternalLink('Privacy Policy')}
                className="block text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => handleExternalLink('Compliance')}
                className="block text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Compliance
              </button>
            </div>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <div className="space-y-2">
              <button 
                onClick={() => handleExternalLink('Documentation')}
                className="block text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Documentation
              </button>
              <button 
                onClick={() => handleExternalLink('Contact')}
                className="block text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Contact
              </button>
              <button 
                onClick={() => handleExternalLink('Community')}
                className="block text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Community
              </button>
            </div>
          </div>
        </div>
        
        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400">
          <p>&copy; 2024 SUI-ndicate. All rights reserved.</p>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
